import z from 'zod';

export type BucketDeleteMessage = z.infer<typeof BucketDeleteMessage>;

export const BucketDeleteMessage = z.object({
    bucketId: z.string(),
    receiptIds: z.array(z.string()),
});
